import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';

// analytics is initialized in App component due to multi brand
export const bootstrap = new BootstrapBrowserBuilder('renter-hub-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: `/renter-hub/log`,
    level: __LOG_LEVEL__,
  })
  .withDatadogPlugin('3a886f88-2154-4c50-ba4c-7a5179a0bf3c', 'pub8e5a8a118fc3fd93433664d44cd46033', 'renter-hub-webapp')
  .build();
